/**
 * Indian-format currency helpers — ₹ + Cr/L/lakh-style abbreviation,
 * with full-precision and percent variants.
 */

export function fmt(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  if (n >= 10000000)
    return '₹' + (n / 10000000).toFixed(2).replace(/\.?0+$/, '') + 'Cr';
  if (n >= 100000)
    return '₹' + (n / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
  if (n >= 1000)
    return '₹' + Math.round(n).toLocaleString('en-IN');
  return '₹' + Math.round(n);
}

export function fmtFull(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  return '₹' + Math.round(n).toLocaleString('en-IN');
}

export function fmtPct(rate: number | null | undefined): string {
  if (!rate) return 'nil';
  return (rate * 100).toFixed(0) + '%';
}
